import { render, staticRenderFns } from "./sellRewardDetail.vue?vue&type=template&id=b841802e&scoped=true"
import script from "./sellRewardDetail.vue?vue&type=script&lang=js"
export * from "./sellRewardDetail.vue?vue&type=script&lang=js"
import style0 from "./sellRewardDetail.vue?vue&type=style&index=0&id=b841802e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b841802e",
  null
  
)

export default component.exports